var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 333,
    height: 180,
    viewBox: "0 0 333 180",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#1450ff",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 90H300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 20L310 90L230 160"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowBlue);
export default __webpack_public_path__ + "static/media/right-arrow-blue.18368f5aa16b9177e393652771993107.svg";
export { ForwardRef as ReactComponent };